import React, { createContext, useContext, useMemo } from 'react';
import type { FC, ReactNode } from 'react';

type CreatePageButtonContextType = {
	contentId?: string | null;
	spaceKey?: string | null;
	contentTitle?: string | null;
};

const CreatePageButtonContext = createContext<CreatePageButtonContextType | undefined>(undefined);

const CreatePageButtonContextProvider: FC<
	CreatePageButtonContextType & { children: ReactNode }
> = ({ children, contentId, spaceKey, contentTitle }) => {
	const contextValue = useMemo<CreatePageButtonContextType>(
		() => ({
			contentId,
			spaceKey,
			contentTitle,
		}),
		[contentId, spaceKey, contentTitle],
	);

	return (
		<CreatePageButtonContext.Provider value={contextValue}>
			{children}
		</CreatePageButtonContext.Provider>
	);
};

const useCreatePageButtonContext = () => {
	const context = useContext(CreatePageButtonContext);
	if (!context) {
		throw new Error(
			'useCreatePageButtonContext must be used within a CreatePageButtonContextProvider',
		);
	}
	return context;
};

export { CreatePageButtonContextProvider, useCreatePageButtonContext };
